<template>
  <div>
    <div class="page-header pr-0">
      <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
      <ol class="breadcrumbs">
          <li class="active"><span>SIRE - Anexos</span></li>
      </ol>
    </div>
    <div class="card mt-3">
      <div class="card-header bg-info">
        <h3 class="my-0">Ventas
          <el-tooltip class="item" effect="dark" content="Ventas emitidas en el sistema." 
            placement="top-start">
            <i class="fa fa-info-circle"></i>
          </el-tooltip>
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group" :class="{'has-danger': errors.period}">
              <label class="control-label">Periodo Contable</label>
              <el-date-picker v-model="form.period"
                placeholder="Seleccione un periodo"
                value-format="yyyy-MM"
                format="MM/yyyy"
                type="month"
              ></el-date-picker>
              <small v-if="errors.period"
                class="form-control-feedback"
                v-text="errors.period"></small>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="control-label">Anexo
                <el-tooltip placement="top-start">
                  <div slot="content">
                    Anexo 3: Reemplaza la propuesta de ventas de SIRE de la Clave Sol.
                  </div>
                  <i class="fa fa-info-circle"></i>
                </el-tooltip>
              </label>
              <el-select v-model="form.appendix" placeholder="Seleccione un anexo">
                <el-option v-for="(appendix, index) in appendices"
                  :key="index"
                  :label="`Anexo - ${appendix}`"
                  :value="appendix"
                ></el-option>
              </el-select>
              <small v-if="errors.appendix"
                class="form-control-feedback"
                v-text="errors.appendix"></small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <el-button type="primary"
              @click="submit"
              :loading="loading_submit"
            >Generar</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      resource: 'sire',
      form: {},
      errors: {},
      appendices: [
        '3',
      ],
      loading_submit: false,
      result: {}
    }
  },

  created() {
    this.initForm()
  },

  watch: {
    'errors.period': {
      handler(value) {
        if (value) {
          this.errors.period = null
        }
      }
    },
    'errors.appendix': {
      handler(value) {
        if (value) {
          this.errors.appendix = null
        }
      }
    }
  },

  methods: {
    initForm() {
      this.form = {
        period: moment().format('YYYY-MM'),
        appendix: '3'
      }
    },

    validateForm() {
      let flag = true
      if (!this.form.period) {
        this.errors.period = 'Seleccione un periodo'
        flag = false
      }
      if (!this.form.appendix) {
        this.errors.appendix = 'Seleccione un anexo'
        flag = false
      }
      return flag
    },

    async submit() {
      try {
        this.loading_submit = true
        this.errors = {}

        const validation = this.validateForm()
        if (!validation) return

        
        const response = await this.$http.post(
          `/${this.resource}/appendices/generate`,
          this.form,
          { responseType: 'blob' }
        )

        
        const contentType = response.headers['content-type'] || ''
        if (contentType.includes('application/zip')) {
          this.downloadZip(response)
          this.$message.success('ZIP generado correctamente.')
        } else {
          
          const text = await response.data.text()
          try {
            const json = JSON.parse(text)
            if (json.success === false) this.$message.error(json.message || 'Error al generar el ZIP.')
            else this.$message.error('Respuesta inesperada del servidor.')
          } catch {
            this.$message.error('No se pudo interpretar la respuesta del servidor.')
          }
        }
      } catch (err) {
        
        if (err.response && err.response.data) {
          const text = await err.response.data.text()
          try {
            const json = JSON.parse(text)
            this.$message.error(json.message || 'Error al generar el ZIP.')
          } catch {
            this.$message.error('Error al generar el ZIP.')
          }
        } else {
          this.$message.error('Error de red al generar el ZIP.')
        }
        console.log(err)
      } finally {
        this.loading_submit = false
      }
    },

    downloadZip(response) {
      
      const disposition = response.headers['content-disposition'] || ''
      let filename = 'appendices.zip'
      const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i.exec(disposition)
      if (match && match[1]) {
        filename = decodeURIComponent(match[1].replace(/(^"|"$)/g, ''))
      }

      const blob = new Blob([response.data], { type: 'application/zip' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
    }

  }
}
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/sire/appendices.vue